/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import usePlacesList from '../../../../ofindo/utils/hasPlaces'
import { KTIcon } from '../../../helpers/components/KTIcon'
import { CircularChart } from '../charts/CircularChart'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../helpers/AssetHelpers'

const CompleteSettings: React.FC = () => {
  const { hasPlaces } = usePlacesList() // Ladezustand und hasPlaces abfragen

  return (
    <>
      {/* begin::Item */}
      <div className='d-flex align-items-center bg-warning rounded ps-7 mb-3'>
        {/* begin::Icon */}
        <span className=' text-warning me-2'>
          <KTIcon iconName='verify' className='text-info fs-1 ms-1 me-4' />
        </span>
        {/* end::Icon */}
        {/* begin::Title */}
        <div className='flex-grow-1'>
          <div className='fw-bold text-gray-800 fs-4'>
            Verfolständigen Sie Ihr Konto
          </div>
        </div>
        {/* end::Title */}
        {/* begin::Chart */}
        <CircularChart chartColor={'info'} chartPercent={74} />
        {/* end::Chart */}
      </div>
      {/* end::Item */}

      {/* begin::Item für "Ihr Ort in der Ofindo WebApp" */}
      <Link to='/places/overview' className='d-flex align-items-center bg-light-info bg-hover-light rounded ps-7 mb-3 p-5'>
        {/* begin::Icon */}
        <span className=' text-info me-5'>
          <img className="h-30px theme-light-show" src={toAbsoluteUrl(`/media/icons/ofindo/places.svg`)} alt="Icon" />
          <img className="h-30px theme-dark-show" src={toAbsoluteUrl(`/media/icons/ofindo/places-dark.svg`)} alt="Icon" />
        </span>
        {/* end::Icon */}
        {/* begin::Title */}
        <div className='flex-grow-1 me-2'>
          <div className='fw-bold text-gray-800 fs-5'>
            Ihr Ort in der Ofindo WebApp
          </div>
          <span className='text-muted  d-block fs-6'>Erstellen Sie ein Partnerprofil</span>
        </div>
        {/* end::Title */}
        {/* begin::Chart */}
        {hasPlaces ? (
          <KTIcon iconName='check-circle' className='text-info fs-1 me-5' />
        ) : (
          <KTIcon iconName='right-square' className='fs-1 me-5' />
        )}
        {/* end::Chart */}
      </Link>
      {/* end::Item */}

      {/* begin::Item */}
      <Link to='/places/overview' className='d-flex align-items-center bg-light-info bg-hover-light rounded ps-7 mb-3 p-5'>
        {/* begin::Icon */}
        <span className=' text-info me-5'>
          <img className="h-30px theme-light-show" src={toAbsoluteUrl(`/media/icons/ofindo/calendar.svg`)} alt="Icon" />
          <img className="h-30px theme-dark-show" src={toAbsoluteUrl(`/media/icons/ofindo/calendar-dark.svg`)} alt="Icon" />
        </span>
        {/* end::Icon */}
        {/* begin::Title */}
        <div className='flex-grow-1 me-2'>
          <a href='#' className='fw-bold text-gray-800 fs-5'>
            Ihre Veranstaltungen in der Ofindo WebApp
          </a>
          <span className='text-muted  d-block fs-6'>Erstellen Sie Ihre erste Veranstaltung</span>
        </div>
        {/* end::Title */}
        {/* begin::Chart */}
        <KTIcon iconName='right-square' className='fs-1 me-5' />
        {/* end::Chart */}
      </Link>
      {/* end::Item */}

      {/* begin::Item */}
      <Link to='/places/overview' className='d-flex align-items-center bg-light-info bg-hover-light rounded ps-7 p-5'>
        {/* begin::Icon */}
        <span className=' text-info me-5'>
          <img className="h-30px theme-light-show" src={toAbsoluteUrl(`/media/icons/ofindo/billing.svg`)} alt="Icon" />
          <img className="h-30px theme-dark-show" src={toAbsoluteUrl(`/media/icons/ofindo/billing-dark.svg`)} alt="Icon" />
        </span>
        {/* end::Icon */}
        {/* begin::Title */}
        <div className='flex-grow-1 me-2'>
          <a href='#' className='fw-bold text-gray-800 fs-5'>
            Verrechnungskonto anlegen
          </a>
          <span className='text-muted d-block fs-6'>Hinterlegen Sie Ihre Buchungsdaten</span>
        </div>
        {/* end::Title */}
        {/* begin::Chart */}
        <KTIcon iconName='right-square' className='fs-1 me-5' />
        {/* end::Chart */}
      </Link>
      {/* end::Item */}
      {/* ... */}
    </>
  )
}

export { CompleteSettings }
